/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as TermsIcon } from "../../../resources/images/ac-terms-modal-icon.svg";

/* Styles */
import styles from "./styles";

const AcTermsModal = ({ showTermsModal, setShowTermsModal }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.termsModal}
      showModal={showTermsModal}
      setShowModal={setShowTermsModal}
      modalIcon={<TermsIcon />}
      modalContent={<Content />}
    />
  );
};

export default AcTermsModal;
